import { FLOWER_IDS, FLOWERS, type FlowerId } from '../../game/flowers';
import type { Tool } from '../../game/interaction';
import { resolveSeed } from '../../game/interaction';
import { ui } from '../store';
import { useGameState, useServices } from '../context';

const TOOL_INFO: ReadonlyArray<{ id: Tool; icon: string; label: string; hint: string }> = [
  { id: 'hand', icon: '✋', label: 'Hand', hint: 'Smart: plant, water & harvest' },
  { id: 'water', icon: '💧', label: 'Water', hint: 'Water plots' },
  { id: 'seeds', icon: '🌱', label: 'Seeds', hint: 'Plant the selected seed' },
  { id: 'shovel', icon: '⛏️', label: 'Shovel', hint: 'Dig up a plant' },
];

export function selectTool(tool: Tool): void {
  ui.tool.value = tool;
}

export function Hotbar() {
  const state = useGameState();
  const { audio } = useServices();
  const owned = FLOWER_IDS.filter((id) => (state.seeds[id] ?? 0) > 0);
  const activeSeed = resolveSeed(state, ui.seed.value);

  const chooseSeed = (id: FlowerId) => {
    audio.play('click');
    ui.seed.value = id;
    if (ui.tool.value === 'water' || ui.tool.value === 'shovel') ui.tool.value = 'hand';
  };

  return (
    <div class="hotbar-wrap">
      <div class="seed-bag" aria-label="Seed bag">
        {owned.length === 0 ? (
          <span class="seed-empty">🌱 No seeds — visit the market stand!</span>
        ) : (
          owned.map((id) => (
            <button
              key={id}
              class={`seed-chip ${id === activeSeed ? 'active' : ''}`}
              onClick={() => chooseSeed(id)}
              aria-pressed={id === activeSeed}
              title={`${FLOWERS[id].name} seeds`}
            >
              <span aria-hidden="true">{FLOWERS[id].emoji}</span>
              <span class="seed-count">{state.seeds[id]}</span>
            </button>
          ))
        )}
      </div>
      <div class="hotbar" role="toolbar" aria-label="Tools">
        {TOOL_INFO.map((tool, i) => (
          <button
            key={tool.id}
            class={`tool ${ui.tool.value === tool.id ? 'active' : ''}`}
            onClick={() => {
              audio.play('click');
              selectTool(tool.id);
            }}
            aria-pressed={ui.tool.value === tool.id}
            title={`${tool.label} (${i + 1}) — ${tool.hint}`}
          >
            <span class="tool-icon" aria-hidden="true">
              {tool.id === 'seeds' && activeSeed ? FLOWERS[activeSeed].emoji : tool.icon}
            </span>
            <span class="tool-label">{tool.label}</span>
            <kbd class="tool-key">{i + 1}</kbd>
          </button>
        ))}
      </div>
    </div>
  );
}
